export const SITE_URL = "fashionvie.maximquiz.com";
